import React from 'react'

function ContactBanner() {
 const title = "Contact Us";

    const iconPaths = [
        "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1z",
        "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.65-.5-.65C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
        "M17,17V3L7,3V17L12,15L17,17M17,21L12,19L7,21V23H17V21M7,1V1H17V1H7Z",
        "M15.5,14h-.79l-.28-.27C15.41,12.59,16,11.11,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5S5.91,16,9.5,16c1.61,0,3.09-.59,4.23-1.57l.27,0.28v0.79l5,4.99L20.49,19l-4.99-5z",
        "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5Z",
        "M17,1.01L7,1C5.9,1,5,1.9,5,3v18c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V3C19,1.9,18.1,1.01,17,1.01z M17,19H7V5h10V19z",
        "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12.5,7H11v6l5.25,3.15l0.75-1.23L12.5,12.5V7z",
        "M12,3L2,12h3v8h14v-8h3L12,3z M17,18H7v-7.81l5-4.5l5,4.5V18z",
        "M21.41,11.58l-9-9C12.05,2.22,11.55,2,11,2H4C2.9,2,2,2.9,2,4v7c0,0.55,0.22,1.05,0.59,1.42l9,9c0.36,0.36,0.86,0.58,1.41,0.58s1.05-0.22,1.41-0.59l7-7C21.78,12.64,22,12.13,22,11.58S21.78,11.02,21.41,10.66z",
        "M18,10h-1.26c-0.51-1.72-1.34-3.29-2.41-4.68l0.91-0.91L13.83,3l-0.91,0.91C11.54,2.83,9.97,2.01,8.26,1.5L8.01,1H5.99L5.74,1.5c-1.72,0.51-3.29,1.34-4.68,2.41L0.15,3L1.57,4.41l0.91-0.91c1.39,1.07,2.96,1.9,4.68,2.41L7.41,6.17C7.15,6.71,7,7.33,7,8v2H2v2h5v6c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2v-6h5v-2H18z",
        "M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z",
        "M11,9H13V7H11V9M11,17H13V11H11V17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
    ];

    const floatingIcons = Array.from({ length: 40 }, (_, i) => ({
        d: iconPaths[i % iconPaths.length],
        top: `${Math.random() * 92}%`,
        left: `${Math.random() * 95}%`,
        size: Math.random() * 10 + 18,
        delay: `${Math.random() * 6}s`,
        dur: `${Math.random() * 4 + 4}s`, 
        rot: Math.random() * 360,
    }));

    return (
        <div style={{ position: 'relative', overflow: 'hidden', width: '100%' }}>
            <style>{`
                @keyframes floatAround {
                    0%, 100% { transform: translate(0, 0) rotate(var(--r)); }
                    50% { transform: translate(15px, -25px) rotate(calc(var(--r) + 20deg)); }
                }

                @keyframes letter-glow {
                    0%, 20%, 100% { color: #0C3D7A; text-shadow: none; }
                    10% { color: #FFFFFF; text-shadow: 0 0 15px rgba(255,255,255,0.9); }
                }

                .banner-container {
                    position: relative;
                    width: 100%;
                    height: 300px;
                    background: #DCEEFF; 
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    border-radius: 8px;
                }

                .bg-icon {
                    position: absolute;
                    fill: #0C3D7A;
                    opacity: 0.08;
                    animation: floatAround var(--dur) infinite ease-in-out;
                    pointer-events: none;
                    z-index: 0;
                }

                .banner-title {
                    font-size: 4.5rem;
                    font-weight: 900;
                    letter-spacing: 6px;
                    text-transform: uppercase;
                    z-index: 1;
                    display: flex;
                    align-items: center; /* Center spaces vertically if needed */
                    font-family: 'Arial Black', Gadget, sans-serif;
                    user-select: none;
                }

                .letter {
                    display: inline-block;
                    animation: letter-glow 4.5s infinite;
                }

                /* This creates the space between the words */
                .title-space {
                    width: 30px; 
                }

                @media (max-width: 768px) {
                    .banner-title { font-size: 2.2rem; letter-spacing: 3px; }
                    .banner-container { height: 180px; }
                    .bg-icon { opacity: 0.05; }
                    .title-space { width: 15px; }
                }
            `}</style>

            <div className="banner-container">
                {floatingIcons.map((icon, i) => (
                    <svg 
                        key={i}
                        className="bg-icon"
                        style={{
                            top: icon.top,
                            left: icon.left,
                            width: icon.size,
                            height: icon.size,
                            animationDelay: icon.delay,
                            '--dur': icon.dur,
                            '--r': `${icon.rot}deg`
                        }}
                        viewBox="0 0 24 24"
                    >
                        <path d={icon.d} />
                    </svg>
                ))}

                <h1 className="banner-title">
                    {title.split("").map((char, index) => {
                        // Check if the current character is a space
                        if (char === " ") {
                            return <span key={index} className="title-space"></span>;
                        }
                        return (
                            <span 
                                key={index} 
                                className="letter"
                                style={{ animationDelay: `${index * 0.18}s` }}
                            >
                                {char}
                            </span>
                        );
                    })}
                </h1>
            </div>
        </div>
    );
};

export default ContactBanner